import React, { createContext, useContext, useState, ReactNode } from 'react';

interface NavigationBlockContextType {
  isNavigationBlocked: boolean;
  setNavigationBlocked: (blocked: boolean) => void;
}

const NavigationBlockContext = createContext<NavigationBlockContextType | undefined>(undefined);

export const NavigationBlockProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  const [isNavigationBlocked, setNavigationBlocked] = useState(false);

  return (
    <NavigationBlockContext.Provider value={{ isNavigationBlocked, setNavigationBlocked }}>
      {children}
    </NavigationBlockContext.Provider>
  );
};

export const useNavigationBlock = () => {
  const context = useContext(NavigationBlockContext);
  if (!context) {
    throw new Error('useNavigationBlock must be used within NavigationBlockProvider');
  }
  return context;
};